<template>
  <Dialog :visible="showDialog" modal
     :style="{ width: '50rem' }" class="mx-4 black-bg">
     <template #header>
        <div class="inline-flex items-center justify-center gap-2">
            <font-awesome-icon class="text-2xl text-[var(--color-orange)]" icon="fa-comments"/>
            <span class="font-bold whitespace-nowrap text-xl">
                {{ $t('ProvideFeedbackComponent.yourFeedback') }}
            </span>
        </div>
     </template>
      <form action="#">
        <div class="flex flex-start my-6 mx-2" >
          <b class="text-lg">
          <label class="w-fit whitespace-nowrap mr-4" v-if="this.name">{{ nameLabel }}</label>
          <label class="w-fit whitespace-nowrap mr-4" v-if="this.name">{{ name }}</label>
          </b>
        </div>
        <Textarea v-model="text" maxlength="5000" class="text-base h-40 w-full" data-testid="user-feedback-text"
          :placeholder="$t('ProvideFeedbackComponent.placeholderText')"></Textarea>
        <div class="flex flex-col items-start my-2">
          <div class="flex flex-row items-center gap-2">
            <Checkbox v-model='anonymous' binary size="medium" data-testid="user-feedback-anonymous"/>
              <b class="text-md">{{ $t('ProvideFeedbackComponent.anonymous') }}</b>
          </div>
          <div>
            <p class="text-sm mt-2">
              <i>{{ $t('ProvideFeedbackComponent.subText') }}</i>
            </p>
          </div>
        </div>
        <div class="feedback-btn-grid">
          <Button class="btn-primary-accent w-48 py-2.5 px-5 text-base sm:text-lg float-right" 
            :disabled="buttonDisabled" data-testid="user-feedback-submit" @click.prevent="submitFeedback" unstyled>
            {{ $t('ProvideFeedbackComponent.sendFeedback') }}
          </Button>
        </div>
      </form>
</Dialog>
</template>

<script>
import { Checkbox, Dialog, Textarea, Button } from 'primevue';

export default {
  name: 'ProvideFeedbackOverlayComponent',
  props: {
    data: Object,
  },
  components: {
    Dialog,
    Textarea,
    Checkbox,
    Button,
  },
  data() {
    return {
      text: '',
      anonymous: true,
      // Mounted under v-if when parent wants the dialog open
      showDialog: true,
    };
  },
  mounted() {
    this.scrollToElement();
  },
  computed: {
    nameLabel() {
      return (this.data.firstName === 'external' ? 'Email:' : 'Name:');
    },
    name() {
      return this.data.name;
    },
    userId() {
      return this.data.userId;
    },
  },
  methods: {
    markAnonymous() {
      this.anonymous = !this.anonymous;
    },
    async submitFeedback() {
      try {
        if (!this.inputCheck()) {
          return;
        }
        this.buttonDisabled = true;
        await this.$store.dispatch('sendUserFeedback', {
          feedbackText: this.text,
          feedbackDate: new Date(),
          pageName: this.$router.currentRoute._rawValue.name,
          userId: (this.anonymous) ? '' : this.userId,
          anonymous: this.anonymous,
          userName: (this.anonymous) ? '-' : this.name,
        });
        this.buttonDisabled = false;
        this.$store.commit('removeFrontendOverlay', this.data.id);
        this.$toast.add({
          severity: 'success',
          summary: this.$t('ProvideFeedbackComponent.feedbackSent'),
          detail: '',
          life: 3000,
        });
      } catch (error) {
        this.buttonDisabled = false;
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ProvideFeedbackComponent.errorCouldNotFeedback'),
          detail: '',
          life: 3000,
        });
      } finally {
        this.$emit('update:visible', false);
      }
    },
    inputCheck() {
      if (this.text.trim() === '') {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('ProvideFeedbackComponent.errorRequired'),
          detail: '',
          life: 3000,
        });
        return false;
      }
      return true;
    },
    scrollToElement() {
      const el = this.$refs.devTipEl;
      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>
